import { jsx as _jsx } from "react/jsx-runtime";
import { SearchProductTile, SearchProductTilePrehydrationClickTrackingWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/SearchProductTile";
import { ProductTileType } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileType";
import { exhaustiveSwitchWithDefault } from "@faire/web--source/common/exhaustiveSwitchWithDefault";
import React from "react";
import { LoggedInProductOnlyProductTile } from "./__internal__/LoggedInProductOnlyProductTile";
import { ProductTileSurfaceContext } from "./ProductTileSurfaceContext";
var ProductTileBase = function(param) {
    var productTile = param.productTile, productTileType = param.productTileType, brand = param.brand, productTileSurface = param.productTileSurface, showVerticalImagery = param.showVerticalImagery, dataTestId = param["data-test-id"];
    if (productTile === undefined) {
        return null;
    }
    switch(productTileType){
        case ProductTileType.SEARCH_PAGE_PRODUCT_TILE:
            var _productTile_product;
            var _productTile_product_token;
            return /*#__PURE__*/ _jsx(ProductTileSurfaceContext.Provider, {
                value: {
                    productTileSurface: productTileSurface
                },
                children: /*#__PURE__*/ _jsx(SearchProductTilePrehydrationClickTrackingWrapper, {
                    productToken: (_productTile_product_token = (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token) !== null && _productTile_product_token !== void 0 ? _productTile_product_token : "",
                    children: /*#__PURE__*/ _jsx(SearchProductTile, {
                        productTile: productTile,
                        brand: brand,
                        "data-test-id": dataTestId
                    })
                })
            });
        case ProductTileType.PRODUCT_ONLY_TILE:
            return /*#__PURE__*/ _jsx(ProductTileSurfaceContext.Provider, {
                value: {
                    productTileSurface: productTileSurface
                },
                children: /*#__PURE__*/ _jsx(LoggedInProductOnlyProductTile, {
                    productTile: productTile,
                    "data-test-id": dataTestId,
                    brand: brand,
                    showVerticalImagery: showVerticalImagery
                })
            });
        default:
            return exhaustiveSwitchWithDefault(null)(productTileType);
    }
};
export var ProductTile = ProductTileBase;
